import { routes } from '../../../constants/routes';

/* eslint-disable object-curly-newline */
const contactSection = {
  'first-section': {
    title: 'Información General',
    content: [
      {
        title: 'Reglas de pronosticos',
        link: `${routes.INFO}/bet-rules`,
      },
      {
        title: 'Depósitos',
        link: `${routes.INFO}/deposits`,
      },
      {
        title: 'Retiros',
        link: `${routes.INFO}/withdrawals`,
      },
      {
        title: 'Límite de pronosticos',
        link: `${routes.INFO}/betting-limit`,
      },
    ],
  },
  'second-section': {
    title: 'Nuestras Secciones',
    content: [
      {
        title: 'Inicio',
        link: routes.HOME,
      },
      {
        title: 'Casino',
        link: routes.CASINO,
      },
      {
        title: 'Deportes',
        link: routes.SPORTS,
      },
      {
        title: 'Perfil',
        link: routes.DASHBOARD,
      },
      {
        title: 'Retiros',
        link: `${routes.DASHBOARD}/withdrawals`,
      },
    ],
  },
  'third-section': {
    title: 'Seguridad & Privacidad',
    content: [
      {
        title: 'Política de Privacidad',
        link: `${routes.INFO}/privacy`,
      },
      {
        title: 'Términos y Condiciones',
        link: `${routes.INFO}/terms-and-conditions`,
      },
      {
        title: 'Condiciones de Bonos',
        link: `${routes.INFO}/bonus-conditions`,
      },
      {
        title: 'Juego Responsable',
        link: `${routes.INFO}/responsibility`,
      },
      {
        title: 'Políticas KYC',
        link: `${routes.INFO}/kyc-policies`,
      },
      {
        title: 'Anti-Lavado de Dinero',
        link: `${routes.INFO}/money-laundering`,
      },
    ],
  },
  'fourth-section': {
    title: '¿Necesitas ayuda?',
    content: [
      {
        title: 'Preguntas Frecuentes',
        link: `${routes.INFO}/faq`,
      },
      {
        title: 'Contáctanos',
        link: 'https://api.whatsapp.com/send?phone=50492062735&text=%C2%A1Hola',
      },
      {
        title: 'Resolución de Disputas',
        link: `${routes.INFO}/dispute-resolution`,
      },
      {
        title: '¿Quieres ser Agente Powerbet?',
        link: `${routes.INFO}/nuevo-agente`,
      },
    ],
  },
};

const paymentMethodsSection = {
  title: 'Métodos de Pago',
  bac: 'BAC',
  bitcoin: 'Criptomonedas',
  tigo: 'Tigo',
  visa: 'Visa',
  pybam: 'Bam',
  ikisi: 'Ikisi',
  pybi: 'Bi',
  super24: 'Super24',
  midas: 'Midas',
  popular: 'Popular',
};

const socialLinks = {
  text: 'Redes Sociales',
};

const contactSectionText = {
  text: 'Soporte',
};

export default { contactSection, paymentMethodsSection, socialLinks, contactSectionText,
};
